import React, { useState } from "react";
import { Modal, Typography } from "antd";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import EditIcon from "../../assets/icons/edit-active.svg";
import ChatWhiteIcon from "../../assets/icons/chat-white.svg";
import { t } from "i18next";
import { ROUTES, TOKENS } from "../../utilities/Constants/Constants";
import "../../pages/ListQuery/listQuery.css"
import { TruncatedModalTitle } from "../dashboard/TruncatedModalTitle";

interface WorkFlowPageLinkDeciderModalProps {
  isVisible: any;
  onChange: () => void;
  onGetURL: any;
  selectedItem: any;
  config?: {showChat?: boolean};
}

const defaultConfig = {
  showChat: true
}

const WorkFlowPageLinkDeciderModal = ({ isVisible, onChange, onGetURL, selectedItem, config={} }: WorkFlowPageLinkDeciderModalProps) => {
  const updatedConfig = {...defaultConfig, ...config}


  return (
    <Modal
      title={false}
      footer={false}
      centered
      open={isVisible?.state}
      onCancel={onChange}

      className="workbentch-upload-modal"
      width={500}
      styles={{ body: { padding: "20px" } }}
      mask={false}
    >
      <TruncatedModalTitle title={selectedItem.workspace_name || selectedItem.filename || selectedItem.name} />
      <div className="d-flex justify-content-center gap-4 my-4">
       
          <div className="d-flex flex-column align-items-center gap-2" onClick={() => sessionStorage.setItem(TOKENS.MODEL_COMPLETED, selectedItem.model_percentage)}>
            <Link
              to={{
                pathname: ROUTES.SEMANTIC_MODEL,
              }}
              state={{ Id: isVisible.Id }}
              className="p-3 workflow-custom-link"
            >
              <Image src={EditIcon} width={30} />
            </Link>
            <Typography.Text className="redirect-modal-button-text">{t('Edit')}</Typography.Text>
          </div>
        
        
            {updatedConfig?.showChat && (
              <div className="d-flex flex-column align-items-center gap-2">
                <button
                  onClick={() => { onGetURL(selectedItem?.secret_key); onChange() }}
                  className="p-3 workflow-custom-link"
                >
                  <Image src={ChatWhiteIcon} width={30} className="color-inverted-icon"/>
                </button>
                <Typography.Text className="redirect-modal-button-text">{t('Chat')}</Typography.Text>
              </div>
            )}

      </div>

    </Modal>
  );
};

export default WorkFlowPageLinkDeciderModal;
